import { defineStore } from "pinia";
import http from "@/http";
import {
  LIST_VEICULO,
  ADD_VEICULO,
  UPDATE_VEICULO,
  DEL_VEICULO,
  LIST_ABASTECIMENTO,
  ADD_ABASTECIMENTO,
  UPDATE_ABASTECIMENTO,
  DEL_ABASTECIMENTO,
  LIST_MANUTENCAO,
  ADD_MANUTENCAO,
  UPDATE_MANUTENCAO,
  DEL_MANUTENCAO,
} from "@/http/url";

export const useVeiculoStore = defineStore("VeiculoStore", {
  state: () => {
    return {
      veiculos: [],
      abastecimentos: [],
      manutencoes: [],
      totalAbastecimentos: Number(0.0),
      totalManutencoes: Number(0.0),
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    //AÇÕES SOBRE OS VEICULOS
    LISTAR_VEICULOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_VEICULO)
          .then((response) => {
            this.veiculos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_VEICULO(veiculo) {
      return http
        .post(ADD_VEICULO, veiculo)
        .then((response) => this.veiculos.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_VEICULO(veiculo) {
      return http
        .put(`${UPDATE_VEICULO + veiculo.id}`, veiculo)
        .then((response) => {
          const index = this.veiculos.findIndex((objeto) => objeto.id === response.data.id);
          this.veiculos[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_VEICULO(id) {
      return http.delete(`${DEL_VEICULO + id}`).then(() => (this.veiculos = this.veiculos.filter((object) => object.id != id)));
    },

    //AÇÕES SOBRE OS ABASTECIMENTOS
    LISTAR_ABASTECIMENTOS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_ABASTECIMENTO + id}`)
          .then((response) => {
            this.abastecimentos = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_ABASTECIMENTO(abastecimento) {
      return http.post(ADD_ABASTECIMENTO, abastecimento).catch((erro) => {
        console.log(erro);
      });
    },

    ALTERAR_ABASTECIMENTO(abastecimento) {
      return http.put(`${UPDATE_ABASTECIMENTO + abastecimento.id}`, abastecimento);
    },

    REMOVER_ABASTECIMENTO(id) {
      return http
        .delete(`${DEL_ABASTECIMENTO + id}`)
        .then(() => (this.abastecimentos = this.abastecimentos.filter((item) => item.id != id)));
    },

    //AÇÕES SOBRE AS MANUTENÇÕES
    LISTAR_MANUTENCOES(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_MANUTENCAO + id}`)
          .then((response) => {
            this.manutencoes = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_MANUTENCAO(manutencao) {
      return http
        .post(ADD_MANUTENCAO, manutencao)
        .then((response) => this.manutencoes.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_MANUTENCAO(manutencao) {
      return http
        .put(`${UPDATE_MANUTENCAO + manutencao.id}`, manutencao)
        .then((response) => {
          const index = this.manutencoes.findIndex((objeto) => objeto.id === response.data.id);
          this.manutencoes[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_MANUTENCAO(id) {
      return http
        .delete(`${DEL_MANUTENCAO + id}`)
        .then(() => (this.manutencoes = this.manutencoes.filter((object) => object.id != id)));
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    //VEICULOS
    getVeiculos() {
      return this.veiculos;
    },

    getTotal() {
      let total = Number(0.0);
      total = parseFloat(this.totalManutencoes) + parseFloat(this.totalAbastecimentos);
      return total;
    },

    getVeiculoById: (state) => {
      return (id) => {
        return state.veiculos.filter((object) => !id || object.id == id);
      };
    },

    getFilterVeiculos: (state) => {
      return (filtro) => {
        let filtrada = state.veiculos;
        filtrada = filtrada.filter(
          (obj) =>
            !filtro ||
            (obj.descricao.includes(filtro.descricao) && obj.placa.includes(filtro.placa) && obj.cor.includes(filtro.cor))
        );
        return filtrada;
      };
    },

    //ABASTECIMENTOS
    getAbastecimentos() {
      return this.abastecimentos;
    },

    getTotalAbastecimentos() {
      return this.totalAbastecimentos;
    },

    getAbastecimentoById: (state) => {
      return (id) => {
        return state.abastecimentos.filter((object) => !id || object.id == id);
      };
    },

    getFilterAbastecimentos: (state) => {
      return (filtro) => {
        let filtrada = state.abastecimentos;
        filtrada = filtrada.filter(
          (obj) => !filtro || (obj.tipo.includes(filtro.tipo) && obj.responsavel.includes(filtro.responsavel))
        );
        return filtrada;
      };
    },

    getPeriodAbastecimentos: (state) => {
      return (periodo) => {
        let filtrada = state.abastecimentos;
        filtrada = filtrada.filter(
          (abastecimento) =>
            new Date(abastecimento.data).getTime() >= new Date(periodo.inicio).getTime() &&
            new Date(abastecimento.data).getTime() <= new Date(periodo.final).getTime()
        );

        let total = Number(0.0);
        filtrada.forEach((abast) => {
          total = total + parseFloat(abast.valor);
        });
        state.totalAbastecimentos = parseFloat(total).toFixed(2);

        return filtrada;
      };
    },

    //MANUTENCAO
    getManutencoes() {
      return this.manutencoes;
    },

    getTotalManutencoes() {
      return this.totalManutencoes;
    },

    getManutencaoById: (state) => {
      return (id) => {
        return state.manutencoes.filter((object) => !id || object.id == id);
      };
    },

    getFilterManutencoes: (state) => {
      return (filtro) => {
        let filtrada = state.manutencoes;
        filtrada = filtrada.filter(
          (obj) => !filtro || (obj.descricao.includes(filtro.descricao) && obj.responsavel.includes(filtro.responsavel))
        );
        return filtrada;
      };
    },

    getPeriodManutencoes: (state) => {
      return (periodo) => {
        let filtrada = state.manutencoes;
        filtrada = filtrada.filter(
          (manutencao) =>
            new Date(manutencao.data).getTime() >= new Date(periodo.inicio).getTime() &&
            new Date(manutencao.data).getTime() <= new Date(periodo.final).getTime()
        );

        let totalM = Number(0.0);
        filtrada.forEach((manut) => {
          totalM = totalM + parseFloat(manut.valor);
        });
        state.totalManutencoes = parseFloat(totalM).toFixed(2);

        return filtrada;
      };
    },

    getVeiculoLoad(state) {
      return state.loaded;
    },
  },
});
